// src/components/ProductDetailsVertical.js
import React from 'react';
import styles from '../styles/ProductDetailsVertical.module.css';

const ProductDetailsVertical = () => {
  return (
    <section className={styles.productDetailsVertical}>
      <div className={styles.container}>
        <div className={styles.detailSection}>
          <h2 className={styles.detailTitle}>产品详情</h2>
          <div className={styles.detailContent}>
            <p>网站A镜像账户是我们为AI爱好者和专业用户精心打造的优质虚拟账户解决方案。每个账户均由我们专业团队严格筛选和配置，确保其功能完整性和使用稳定性。</p>
            <p>作为镜像账户，它完整复制了官方账户的所有功能和特性，让您无需繁琐的注册和验证过程，即可立即开始使用网站A的全部功能。我们的镜像技术确保账户行为模式与真实用户一致，大大降低了被检测和封禁的风险。</p>
            <p>此账户特别适合需要批量测试、数据分析或者开发AI应用的专业用户，能够为您节省大量时间和精力。我们提供完善的售后服务和技术支持，确保您的使用体验顺畅无忧。</p>
            <div className={styles.productComparison}>
              <h3>产品对比</h3>
              <table className={styles.comparisonTable}>
                <thead>
                  {[
                    <tr key="header">
                      <th>功能/特性</th>
                      <th>普通账户</th>
                      <th>镜像账户</th>
                      <th>成品号</th>
                    </tr>,
                  ]}
                </thead>
                <tbody>
                  {[
                    <tr key="1"><td>注册难度</td><td>高</td><td>无需注册</td><td>无需注册</td></tr>,
                    <tr key="2"><td>验证要求</td><td>电话/邮箱多重验证</td><td>已预先验证</td><td>已预先验证</td></tr>,
                    <tr key="3"><td>功能完整性</td><td>完整</td><td>完整</td><td>完整</td></tr>,
                    <tr key="4"><td>历史记录</td><td>无</td><td>基础历史记录</td><td>丰富历史记录</td></tr>,
                    <tr key="5"><td>账户等级</td><td>入门级</td><td>标准级</td><td>高级/VIP</td></tr>,
                    <tr key="6"><td>使用寿命</td><td>不稳定</td><td>中等稳定</td><td>高度稳定</td></tr>,
                    <tr key="7"><td>价格</td><td>免费/低价</td><td>中等</td><td>较高</td></tr>,
                    <tr key="8"><td>技术支持</td><td>无</td><td>基础支持</td><td>全方位支持</td></tr>,
                  ]}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className={styles.detailSection}>
          <h2 className={styles.detailTitle}>账户特点</h2>
          <div className={styles.detailContent}>
            <ul className={styles.featuresList}>
              <li><i className="fas fa-check-circle"></i> 完整镜像官方账户，功能无缺失</li>
              <li><i className="fas fa-check-circle"></i> 预先配置完整的个人资料和使用历史</li>
              <li><i className="fas fa-check-circle"></i> 经过专业团队严格测试和优化</li>
              <li><i className="fas fa-check-circle"></i> 稳定性高，远低于普通账户的封禁风险</li>
              <li><i className="fas fa-check-circle"></i> 即买即用，无需繁琐的注册和验证过程</li>
              <li><i className="fas fa-check-circle"></i> 提供7天售后保障服务</li>
              <li><i className="fas fa-check-circle"></i> 技术团队24/7在线支持</li>
            </ul>
          </div>
        </div>

        <div className={styles.detailSection}>
          <h2 className={styles.detailTitle}>技术规格</h2>
          <div className={styles.detailContent}>
            <table className={styles.specsTable}>
              <tbody>
                {[
                  <tr key="1"><th>账户类型</th><td>网站A镜像账户</td></tr>,
                  <tr key="2"><th>使用权限</th><td>标准版功能完整访问权限</td></tr>,
                  <tr key="3"><th>API调用限制</th><td>每日1000次</td></tr>,
                  <tr key="4"><th>支持设备</th><td>PC, 移动设备, 平板</td></tr>,
                  <tr key="5"><th>地区限制</th><td>全球可用</td></tr>,
                  <tr key="6"><th>更新频率</th><td>每月定期更新</td></tr>,
                  <tr key="7"><th>账户有效期</th><td>根据选择的套餐而定（月卡/季卡/年卡）</td></tr>,
                  <tr key="8"><th>交付方式</th><td>数字交付 - 即时</td></tr>,
                ]}
              </tbody>
            </table>
          </div>
        </div>

        <div className={styles.detailSection}>
          <h2 className={styles.detailTitle}>常见问题</h2>
          <div className={styles.detailContent}>
            <div className={styles.faqItem}>
              <div className={styles.faqQuestion}>
                <i className="fas fa-question-circle"></i>
                <span>什么是镜像账户？</span>
              </div>
              <div className={styles.faqAnswer}>
                镜像账户是指由我们技术团队完全复制并配置好的虚拟账户，与官方账户功能完全一致，但已经预先完成了注册和验证流程，您可以直接使用。
              </div>
            </div>
            <div className={styles.faqItem}>
              <div className={styles.faqQuestion}>
                <i className="fas fa-question-circle"></i>
                <span>账户安全性如何？</span>
              </div>
              <div className={styles.faqAnswer}>
                所有账户均经过严格测试和优化，稳定性远高于普通自行注册的账户。我们使用专业的隐私保护技术，最大程度降低被检测和封禁的风险。
              </div>
            </div>
            <div className={styles.faqItem}>
              <div className={styles.faqQuestion}>
                <i className="fas fa-question-circle"></i>
                <span>购买后如何获取账户？</span>
              </div>
              <div className={styles.faqAnswer}>
                购买成功后，系统将立即通过您注册的邮箱发送账户信息，包括登录凭证和使用说明。您也可以在个人中心的"我的订单"中查看和管理所有购买的账户。
              </div>
            </div>
            <div className={styles.faqItem}>
              <div className={styles.faqQuestion}>
                <i className="fas fa-question-circle"></i>
                <span>如果账户出现问题怎么办？</span>
              </div>
              <div className={styles.faqAnswer}>
                我们提供7天的售后保障服务。如果在使用过程中遇到任何问题，可以通过网站右下角的在线客服或<a href="mailto:support@example.com">support@example.com</a>与我们联系，技术团队将24/7为您提供支持。
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductDetailsVertical;